const data = [
    // {
    //     "name": "周晓波",
    //     "en_name": "Xiaobo Zhou",
    // },
    {
        "name": "徐天一",
        "en_name": "Tianyi Xu",
    },
    {
        "name": "陈宁",
        "en_name": "Ning Chen",
    },
    {
        "name": "池建成",
        "en_name": "Jiancheng Chi",
    },
    {
        "name": "张松伟",
        "en_name": "Songwei Zhang",
    },
    {
        "name": "赵颖颖",
        "en_name": "Yingying Zhao",
    },
    {
        "name": "Adil",
        "en_name": "Adil",
    },
    {
        "name": "曹桢瑞",
        "en_name": "Zhenrui Cao",
    },
    {
        "name": "杨欣微",
        "en_name": "Xinwei Yang",
    },

    {
        "name": "沙哲一",
        "en_name": "Zheyi Sha",
    },
    {
        "name": "杨欣捷",
        "en_name": "Xinjie Yang",
    },
    {
        "name": "孙景晨",
        "en_name": "Jingchen Sun",
    },
    {
        "name": "任林杰",
        "en_name": "Linjie Ren",
    },
    {
        "name": "于逸",
        "en_name": "Yi Yu",
    },
    {
        "name": "刘兆达",
        "en_name": "Zhaoda Liu",
    },
    {
        "name": "牛梓雨",
        "en_name": "Ziyu Niu",
    },
    {
        "name": "曹颂",
        "en_name": "Song Cao",
    },
    {
        "name": "李季桥",
        "en_name": "Jiqiao Li",
    },
    {
        "name": "黄晓琛",
        "en_name": "Xiaochen Huang",
    },
    {
        "name": "苏昊",
        "en_name": "Hao Su",
    },
    {
        "name": "甘子奇",
        "en_name": "Ziqi Gan",
    },
    {
        "name": "徐志强",
        "en_name": "Zhiqiang Xu",
    }
];

export default data;
